<span class="snackbar-content">
  <mat-icon class="status-icon">{{ iconName }}</mat-icon>
  <span class="message">{{ data?.message }}</span>
</span>
